import { Link } from 'react-router-dom';

interface AuthPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AuthPromptModal = ({ isOpen, onClose }: AuthPromptModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
              <i className="ri-lock-line text-xl"></i>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Sign in to checkout</h2>
              <p className="text-sm text-gray-500">Secure your purchases and save downloads</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 cursor-pointer"
            aria-label="Close"
            type="button"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="space-y-4">
          <p className="text-gray-600">
            You&apos;ll need an account to complete checkout. Sign in or create a free account to
            continue with secure MPESA or card payments.
          </p>

          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/signin"
              onClick={onClose}
              className="inline-flex flex-1 items-center justify-center rounded-lg bg-emerald-600 px-4 py-3 font-semibold text-white transition-colors hover:bg-emerald-700"
            >
              Sign in
            </Link>
            <Link
              to="/signup"
              onClick={onClose}
              className="inline-flex flex-1 items-center justify-center rounded-lg border border-gray-200 px-4 py-3 font-semibold text-gray-900 transition-colors hover:border-emerald-200 hover:bg-emerald-50"
            >
              Create account
            </Link>
          </div>

          <p className="text-sm text-gray-500">
            Need help?{' '}
            <a href="/support" className="text-emerald-600 hover:text-emerald-700">
              Contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
